import { catalog } from "../i18n.js";

/** The account at the foot of the roster and its menu (components/AccountMenu.tsx). */
export const ACCOUNT_MENU = catalog(
  {
    thisComputer: "This computer",
    account: "Account",
    settings: "Settings",
    logOut: "Log out",
    weeklyUsage: "Weekly usage",
    monthlyUsage: "Monthly usage",
    noLimit: "No limit",
    /** `credits` is account.ts's "4.2 of 10 credits", already in the app's language. */
    used: (credits: string) => `${credits} used`,
    resets: (when: string) => `Resets ${when}`,
  },
  {
    thisComputer: "Komputer ini",
    account: "Akun",
    settings: "Pengaturan",
    logOut: "Keluar",
    weeklyUsage: "Pemakaian mingguan",
    monthlyUsage: "Pemakaian bulanan",
    noLimit: "Tanpa batas",
    used: (credits: string) => `${credits} terpakai`,
    resets: (when: string) => `Direset ${when}`,
  },
);
